export const items = [
  {
    id: "id-1",
    to: "/",
    text: "Home",
    private: true,
  },
  {
    id: "id-2",
    to: "/useful-info",
    text: "Materials",
    private: true,
  },
  {
    id: "id-3",
    to: "/contacts",
    text: "Contacts",
    private: false,
  },
];
